import React, { useState} from "react"
import ApiService from "@bodeboca/api"
import Expert from "./expert"
import "../../../../../css/slick-theme.scss"
import "../../../../../css/slick.scss"

import Slider from "react-slick"
import CommonUtils from "@bodeboca/utils"
import {useTranslation} from "react-i18next"
import Header from "@bodeboca/common/components/header"
import Arrows from "@bodeboca/common/components/arrows"

const ExpertsSlider = () => {
  const {t} = useTranslation()
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 3,
    initialSlide: CommonUtils.getFlechazosInitialSlide() !== -1 ? CommonUtils.getFlechazosInitialSlide() : 0,
    prevArrow: <Arrows isPrevious={true}/>,
    nextArrow: <Arrows isPrevious={false}/>,
    responsive: [{
      breakpoint: 1350, settings: {
        slidesToShow: 5, slidesToScroll: 3,
      },
    }, {
      breakpoint: 1246, settings: {
        slidesToShow: 4, slidesToScroll: 2
      },
    }, {
      breakpoint: 768, settings: {
        className: "center",
        infinite: false,
        slidesToShow: 3.5,
        variableWidth: false,
        slidesToScroll: 2
      },
    },],
  }

  function CustomArrow(props) {
    return (<li
      className={props.previous ? "pager-previous" : 'pager-next'}
      onClick={props.onClick}>
      <span
        className={"icon " + (props.previous ? "bbicon-chevron-left" : "bbicon-chevron-right")}>
      </span>
    </li>)
  }
  const initialItem = () => {
    let flechadores = ApiService.getFlechazos()
    {
      if (CommonUtils.getFlechazosInitialSlide() !== -1) {
        return flechadores[CommonUtils.getFlechazosInitialSlide()]
      }
      return undefined
    }
  }

  const [selectedItem, setSelectedItem] = useState(initialItem())
  const [items, setItems] = useState(ApiService.getFlechazos())
  const [isDetailOpen, setIsDetailOpen] = useState(true)


  function selectItem(item) {
    setSelectedItem(item)
    window.postMessage({
      type: "filterRefine",
      attribute: CommonUtils.replacePlaceholders("{language}.flechazo_user"),
      value: item.id,
    })
  }

  function toggleInfo() {
    setIsDetailOpen(!isDetailOpen)
    CommonUtils.onStateChange()
  }
  let title = t('Flechazos')

  if (selectedItem) {
    title = selectedItem.label
  }

  return (<div className={"slider-container"}>
    <Header
      iconClass={'flechazo-icon-bold'}
      subtitle={t('Las recomendaciones personales de nuestro comité de cata')}
      title={title}/>
    <>
      <h3 className={'section-title'}>{t('Equipo de Expertos')}</h3>
      <Slider {...settings}>
        {items.map((item) => (<div key={item['id']}>
          <Expert
            item={item}
            selected={selectedItem === undefined ? false : (item['id'] === selectedItem['id'])}
            onSelect={selectItem}/>
        </div>))}
      </Slider>
    </>

    {selectedItem !== undefined && selectedItem['user_full_picture'] !== null && selectedItem['bio'] !== null && <div className={"slider-bottom"}>
      <div
        className={"detail-wrapper " + (isDetailOpen ? "open" : "closed")}>
        <div className={"image-wrapper"}>
          <img src={selectedItem["user_full_picture"]}/>
        </div>
        <div className={"info-wrapper"}>
          <h4>{selectedItem["label"]}</h4>
          <h5>{selectedItem["position"]}</h5>
          <div
            dangerouslySetInnerHTML={{__html: selectedItem["biography"]}}/>
        </div>
      </div>
      <div
        className={"show-more " + (isDetailOpen ? "open" : "")}
        onClick={() => toggleInfo()}>
        {isDetailOpen ? t("Hide Bio") : t("Show Bio")}
        <span className={"bbicon bbicon-chevron-down"}/>
      </div>
    </div>}
  </div>)
}

export default ExpertsSlider
